import { ExcelExport as CarsExcelExport } from "../form/dataforms/cars";
import { ExcelExport as FlightExcelExport } from "../form/dataforms/flight";
import { ExcelExport as SpendingExcelExport } from "../form/dataforms/spending";
const ExportButtonsBulkUpload = {
  cars: <CarsExcelExport />,
  flight: <FlightExcelExport />,
  spending: <SpendingExcelExport />,
};
export default ExportButtonsBulkUpload;
